export default class Store {
    protected url = `https://api.postin.app/api`
}
